import { Card, CardContent, CardHeader } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { Widget } from "./types";

export function MarkdownCard({ widget }: { widget: Widget }) {
  const body = (widget.config?.body as string | undefined) ?? "";
  return (
    <Card variant="outlined">
      {widget.title && (
        <CardHeader
          title={widget.title}
          titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
          sx={{ pb: 1 }}
        />
      )}
      <CardContent sx={{ pt: 0 }}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{body}</ReactMarkdown>
      </CardContent>
    </Card>
  );
}
